import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import "./Navbar.css";
// Assets
import logo from "../../assets/Oakmate.svg";
import dotbutton from "../../assets/dotdownload.svg";
import downloadIcon from "../../assets/downloadWhite.svg";
import menudot from "../../assets/menudot.svg";

function Navbar({ isDownloadVisible }) {
    const [isDownloadHovered, setIsDownloadHovered] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    if (isDownloadVisible === undefined) {
        isDownloadVisible = false;
    }
    // Animation variants for the icons
    const iconVariants = {
        initial: (isDot) => ({
            opacity: 0,
            scale: 0.3,
            rotate: isDot ? 0 : -90,
            x: "-50%",
            y: "-50%",
        }),
        animate: {
            opacity: 1,
            scale: 1,
            rotate: 0,
            x: "-50%",
            y: "-50%",
            transition: {
                type: "spring",
                stiffness: 300,
                damping: 20,
                duration: 0.4,
            },
        },
        exit: (isDot) => ({
            opacity: 0,
            scale: 0.3,
            rotate: isDot ? 90 : 0,
            x: "-50%",
            y: "-50%",
            transition: {
                duration: 0.2,
                ease: "anticipate",
            },
        }),
    };

    // Animation variants for the text
    const textVariants = {
        initial: { x: 0 },
        hovered: {
            x: "-10px",
            transition: {
                type: "spring",
                stiffness: 300,
                damping: 20,
                duration: 0.3,
            },
        },
    };

    return (
        <nav className="navbar" aria-label="Main Navigation">
            <div className="navbar-container">
                <header className="logo-container">
                    <Link
                        to="/"
                        style={{ textDecoration: "none", color: "inherit" }}
                        aria-label="Home"
                    >
                        <img src={logo} alt="Oakmate Logo" className="logo" />
                    </Link>
                </header>
                <div className="navbar-topActions-container">
                    {isDownloadVisible && (
                        <motion.button
                            type="button"
                            className="download-button"
                            onMouseEnter={() => setIsDownloadHovered(true)}
                            onMouseLeave={() => setIsDownloadHovered(false)}
                            onClick={() => {
                                window.open(
                                    "https://chromewebstore.google.com/detail/oakmate-game-review/fdledmdlgggnfddaeillbpahblnblbne",
                                    "_blank",
                                    "noopener,noreferrer"
                                );
                            }}
                            // onClick={() => {
                            //     navigate("/download");
                            // }}
                            aria-label="Download Oakmate"
                        >
                            <motion.span
                                className="button-download-text"
                                variants={textVariants}
                                animate={
                                    isDownloadHovered ? "hovered" : "initial"
                                }
                            >
                                Add to Chrome
                            </motion.span>
                            <span
                                className="icon-animation-container"
                                aria-hidden="true"
                            >
                                <AnimatePresence mode="wait">
                                    {!isDownloadHovered ? (
                                        <motion.img
                                            key="dot"
                                            className="button-icon-dot"
                                            src={dotbutton}
                                            alt=""
                                            custom={true}
                                            variants={iconVariants}
                                            initial="initial"
                                            animate="animate"
                                            exit="exit"
                                        />
                                    ) : (
                                        <motion.img
                                            key="download"
                                            className="button-icon-download"
                                            src={downloadIcon}
                                            alt=""
                                            custom={false}
                                            variants={iconVariants}
                                            initial="initial"
                                            animate="animate"
                                            exit="exit"
                                        />
                                    )}
                                </AnimatePresence>
                            </span>
                        </motion.button>
                    )}
                    <button
                        className="menu-button"
                        aria-haspopup="true"
                        aria-expanded={isMenuOpen}
                        aria-controls="main-menu-list"
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                        type="button"
                    >
                        <span className="menu-button-container">
                            <span className="button-menu-text">
                                {isMenuOpen ? "CLOSE" : "MENU"}
                            </span>
                            <img
                                className="menu-dot"
                                src={menudot}
                                alt="Menu dot icon"
                                style={{
                                    transform: isMenuOpen
                                        ? "rotate(90deg)"
                                        : "rotate(0deg)",
                                    transition: "transform 0.3s ease-in-out",
                                }}
                            />
                        </span>
                    </button>
                    <AnimatePresence>
                        {isMenuOpen && (
                            <motion.ul
                                className="menu-dropdown"
                                id="main-menu-list"
                                initial={{ opacity: 0, y: -20 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -20 }}
                                transition={{
                                    type: "spring",
                                    stiffness: 300,
                                    damping: 20,
                                    duration: 0.3,
                                }}
                                role="menu"
                            >
                                <li role="none">
                                    <Link
                                        to="/"
                                        className="menu-item"
                                        onClick={() => setIsMenuOpen(false)}
                                        role="menuitem"
                                    >
                                        HOME
                                    </Link>
                                </li>
                                <li role="none">
                                    <Link
                                        to="/app"
                                        className="menu-item"
                                        onClick={() => setIsMenuOpen(false)}
                                        role="menuitem"
                                    >
                                        APP
                                    </Link>
                                </li>
                                <li role="none">
                                    <Link
                                        to="/blog"
                                        className="menu-item"
                                        onClick={() => setIsMenuOpen(false)}
                                        role="menuitem"
                                    >
                                        BLOG
                                    </Link>
                                </li>
                                <li role="none">
                                    <Link
                                        to="/account"
                                        className="menu-item"
                                        onClick={() => setIsMenuOpen(false)}
                                        role="menuitem"
                                    >
                                        PROFILE
                                    </Link>
                                </li>
                                <li role="none">
                                    <a
                                        href="https://chromewebstore.google.com/detail/oakmate-game-review/fdledmdlgggnfddaeillbpahblnblbne"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="menu-item download-menu-item-cta"
                                        onClick={() => setIsMenuOpen(false)}
                                        role="menuitem"
                                    >
                                        DOWNLOAD
                                    </a>
                                </li>
                            </motion.ul>
                        )}
                    </AnimatePresence>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
